import React from "react";
import "./Loader.css"; // Import the CSS file
import loader from "../../../../_assets/images/agnostic-flow/loader.gif";

interface LoaderProps {
  isLoading?: boolean; // Optional prop to control whether the loader is visible (default is false)
  loaderImage?: string; // Optional prop to specify the loader image (default can be set to a path)
}

const Loader: React.FC<LoaderProps> = ({ isLoading = false }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <div className="loader-wrapper">
      <img src={loader} alt="Loading..." width={100} height={100} />
    </div>
  );
};

export default Loader;
